import { render } from "./FormEditAccount.vue?vue&type=template&id=5c68967e&scoped=true"
import script from "./FormEditAccount.vue?vue&type=script&lang=js"
export * from "./FormEditAccount.vue?vue&type=script&lang=js"

import "./FormEditAccount.vue?vue&type=style&index=0&id=5c68967e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c68967e"]])

export default __exports__